import { camelCase, isUndefined } from 'lodash';

const deeplyCamelize = obj => {
  if (isUndefined(obj)) return obj;
  if (Array.isArray(obj)) {
    return obj.map(v => deeplyCamelize(v));
  }
  if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: deeplyCamelize(obj[key]),
      }),
      {},
    );
  }
  return obj;
};

export default deeplyCamelize;
